module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vbassets/_next/static/images/Tinyhood-d6677d869eadbe0846afd733963a5be5.svg";